import React, { Fragment } from 'react';

import { DodgeFront } from '../../../../images/UberTorontoLinks';
import { dodgeSideViewLeft } from '../../../../images/landingLinks';

import offerIcon from '../../../../images/Icons/offer-icon.svg';
import trainingIcon from '../../../../images/Icons/training-icon.svg';
import feesIcon from '../../../../images/Icons/fees-icon.svg';
import bonusIcon from '../../../../images/Icons/bonus-icon.svg';

import Heading from '../Shared/Heading';
import WhyDrive from '../Shared/WhyDrive';
import DodgeTop from '../../UberToronto/DodgeTop';
import FleetFaq from '../Shared/FleetFaq';
import WhyWait from '../Shared/WhyWait';
import TorontoFooter from '../../../Layout/TorontoFooter';

import ScrollLock from 'react-scrolllock';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const ProContainer = ({ appFormat }) => (
  <Fragment>
    <ScrollLock>
      <div className="landing__scroll">
        <Heading
          header="Autzu PLUS"
          price="$4"
          notes={['Higher earnings', 'More benefits', 'Lower fees']}
          image={DodgeFront}
          icon={<FontAwesomeIcon icon={faPlus} fixedWidth size="1x" />}
          appFormat={appFormat}
        />
        <WhyDrive
          header="Why Autzu PLUS?"
          cards={cardContent}
          topView={<DodgeTop />}
          pro={false}
        />
        <FleetFaq faqContent={faqContent} />
        {appFormat ? null : (
          <WhyWait carImage={dodgeSideViewLeft} appFormat={appFormat} />
        )}
        {appFormat ? null : <TorontoFooter />}
      </div>
    </ScrollLock>
  </Fragment>
);

export default ProContainer;

const cardContent = [
  {
    icon: offerIcon,
    title: 'Earn more!',
    text:
      'Enjoy a 40% reduction in Uber service fees on all UberX and UberASSIST trips received by Autzu PLUS. (15% instead of 25%)'
  },
  {
    icon: trainingIcon,
    title: 'Accessible vehicle training',
    text:
      'We provide free online and in-person accessible vehicle training, which is needed in order for you to drive with Autzu PLUS and receive UberWAV and UberASSIST trips.'
  },
  {
    icon: feesIcon,
    title: 'No Uber service fees for UberWAV trips',
    text:
      'When you complete a trip on UberWAV, there is no Uber service fee - that means you keep all your earnings.',
    link: {
      text: 'Learn more about UberWAV',
      href:
        'https://www.uber.com/en-CA/drive/toronto/resources/wav-rental-program'
    }
  },
  {
    icon: bonusIcon,
    title: 'Extra incentives',
    text:
      'Pay 0% Uber service fee and receive a $10 bonus every time you complete an UberWAV trip.'
  }
];

const faqContent = [
  {
    title: 'What is Autzu PLUS?',
    text:
      'Autzu PLUS is our fleet of wheelchair accessible vehicles (WAVs). These vehicles allow you to receive UberX, UberAssist and UberWAV trip requests. It’s just as flexible and easy to use as Autzu PRO, and it comes with all the same great features: maintenance, insurance, parking and 24/7 emergency support. Autzu PLUS usage fees are $4.50 per hour (plus tax).',
    link: {
      text: 'Learn more about our UberWAV partnership',
      title: 'here.',
      href:
        'https://www.uber.com/en-CA/drive/toronto/resources/wav-rental-program'
    }
  },
  {
    title: 'What kind of vehicles are available on Autzu PLUS?',
    text:
      'Autzu provides Dodge Grand Caravans that are modified to be wheelchair-accessible vehicles.'
  },
  {
    title: 'Who can drive on Autzu PLUS?',
    text:
      "The sign-up process for Autzu PLUS is just as easy as our Autzu PRO sign-up process. To drive our Autzu PLUS vehicles, you must take a quick online course which explains how to assist people in wheelchairs. When you pick up a vehicle for your first time slot, you’ll complete a short, in-person practical exam to review Autzu's procedure on wheelchair and passenger safety and securement."
  }
];



// WEBPACK FOOTER //
// ./src/components/Static/TorontoFleets/AutzuPlus/PlusContainer.js